module.exports = __webpack_public_path__ + "img/img-129.5e99cf71.png";